import createReducer from 'Utils/createReducer';
import TYPES from 'Catalog/types';

const initialState = {
  value: '',
  category: null,
  sub_category: null,
};

export default createReducer(initialState, {
  [TYPES.CLEAR_SEARCH]: () => ({ ...initialState }),
});
